/*!
 * Adapted from jQuery UI core
 * Taken from https://github.com/reactjs/react-modal/blob/master/src/helpers/tabbable.js
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
var tabbableNode = /input|select|textarea|button|object/;
export function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0; // If the node is empty, this is good enough

  if (zeroSize && !element.innerHTML) return true; // Otherwise we need to check some styles

  var style = window.getComputedStyle(element);
  var isDisplayNone = style.getPropertyValue('display') === 'none';
  var isHidden = style.getPropertyValue('visibility') === 'hidden';
  if (isDisplayNone || isHidden) return true;
  return zeroSize ? style.getPropertyValue('overflow') !== 'visible' : isDisplayNone || isHidden;
}
export function visible(element) {
  var parentElement = element;

  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }

  return true;
}
export function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var isElementVisible = visible(element);
  if (!isElementVisible) return false;
  if (nodeName === 'a' && (element.href || isTabIndexNotNaN)) return true;
  if (tabbableNode.test(nodeName) && !element.disabled) return true;
  if (isTabIndexNotNaN) return true;
  return false;
}

function getTabIndex(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex); // eslint-disable-line no-restricted-globals

  return {
    value: tabIndex,
    isNaN: isTabIndexNaN
  };
}

export function tabbable(element) {
  var tabIndex = getTabIndex(element);
  return (tabIndex.isNaN || tabIndex.value >= 0) && focusable(element, !tabIndex.isNaN);
}
export default function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}
export function findFocusable(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function (el) {
    return focusable(el, !getTabIndex(el).isNaN);
  });
}
export function findTabbableBoundaries(element) {
  var focusableEls = findTabbableDescendants(element);

  if (!focusableEls.length) {
    return null;
  }

  return {
    first: focusableEls[0],
    last: focusableEls[focusableEls.length - 1]
  };
}